import { render, staticRenderFns } from "./AdministratorBase.vue?vue&type=template&id=10b0648e&scoped=true&"
import script from "./AdministratorBase.vue?vue&type=script&lang=js&"
export * from "./AdministratorBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0648e",
  null
  
)

export default component.exports